import { IConvenioPagedResponse } from "models/response/convenio-paged-response";

export interface ConvenioDetailsState {
  convenioDetails: IConvenioPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setConvenioDetails: 'setConvenioDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface ConvenioDetailsAction {
  type: ActionType;
  payload: any;
}

export const ConvenioDetailsReducer = (
  state: ConvenioDetailsState,
  action: ConvenioDetailsAction
): ConvenioDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setConvenioDetails:
      return { ...state, convenioDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
